import { useContext } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { hasAccessToDashboard } from "../../helpers/auth";
import { CurrentUserContext } from "../../contexts/CurrentUser.context";

const RequireAuth = () => {
  const { token } = useContext(CurrentUserContext);
  const { walletCode } = useParams(); // Haal de walletCode uit de URL

  if (!token) return <Navigate to="/login" replace />;
  

  return <Outlet />;
};

export default RequireAuth;
